import axios from "axios";

export const campaigns = axios.create({
  baseURL: `${process.env.REACT_APP_API_PROMOTIONS}/Campaigns`,
});

export const ads = axios.create({
  baseURL: `${process.env.REACT_APP_API_PROMOTIONS}/Ads`,
});
